import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiRelatorio = {
    relatorioAmbiente: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/relatorio/ambiente`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioAmbiente: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/relatorio/ambiente`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioChiller: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/relatorio/chiller`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioCompressor: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/relatorio/compressor`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioCondensacao: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/relatorio/condensacao`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioCondensador: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/relatorio/condensador`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioRegime: async (unidadeId, fusoData, periodo) => {
        const URL = `${apiLink()}api/relatorio/regime?periodo=${periodo}`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioEquipamentos: async (unidadeId, timeZoneOffset) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/equipamentos/${timeZoneOffset}`;
        return await axiosInstance.get(URL, config)
            .then((res) => res)
            .catch(error => {throw new Error('Erro ao buscar os dados:', error)})
    },
    relatorioLeituraRegime: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leituras-regimes`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraAmbiente: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leituras-ambientes`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraChiller: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leituras-chillers`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraCompressor: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leituras-compressores`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraCondensador: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leituras-condensadores`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioAlarmes: async (unidadeId, fusoData) => {
        const URL = `${apiLink()}api/alarme/relatorio`;
        return await axiosInstance.post(URL, fusoData)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    relatorioAlarmesExcel: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/alarmes`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    producaoDiariaExcel: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/producao-diaria`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraCondensacao: async (unidadeId, dataInfo) => {
        const config = {
			responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leituras-condensacao`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraEnergia: async (unidadeId, dataInfo) => {
        const config = {
            responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leitura-energia`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioLeituraProduto: async (unidadeId, dataInfo) => {
        const config = {
            responseType: 'blob'
        };
        const URL = `${apiLink()}api/relatorio/leitura-produto`;
        return await axiosInstance.post(URL, dataInfo, config)
            .then((res) => res)
            .catch(error => {throw new Error(error)})
    },
    relatorioManutencao: async (periodo) =>
        axiosInstance.post(`${apiLink()}api/relatorio/manutencao`, periodo, { responseType: 'blob' }),
}

export default apiRelatorio; 